"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntercomEventType = void 0;
var IntercomEventType;
(function (IntercomEventType) {
    IntercomEventType["UserStartedPokerGame"] = "user-started-poker-game";
    IntercomEventType["UserCopiedPokerInvitationLink"] = "user-copied-poker-invitation-link";
    IntercomEventType["UserFailedToAddACommentToPlanningPokerTask"] = "user-failed-to-add-a-comment-to-planning-poker-task";
    IntercomEventType["JiraReconnectClicked"] = "jira-reconnect-clicked";
    IntercomEventType["JiraConnectClicked"] = "jira-connect-clicked";
})(IntercomEventType = exports.IntercomEventType || (exports.IntercomEventType = {}));
//# sourceMappingURL=intercom.js.map